<script setup>
  const emits = defineEmits(['click'])
</script>

<template>
  <div class="back-btn" @click="emits('click')">
    <
  </div>
</template>

<style scoped lang="scss">
  .back-btn {
    width: 38px;
    height: 38px;

    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 8px;
    border: 1px solid var(--border-color);
    background: var(--element-bg);
    cursor: pointer;

    @media (max-width: 920px) {
      background: var(--layout-bg);
    }
  }
</style>